// Registers the service worker (public/service-worker.js) that keeps the application in the browser: with it the cabinet
// opens without a connection. Only in the built application: in the development server old copies would hide the changes.
// The build number is in the address: a new build is a new worker, which saves the new files.
export const registerServiceWorker = () => {
    if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
        return;
    }

    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register(`${process.env.BASE_URL}service-worker.js?v=${process.env.VUE_APP_BUILD}`)
            .catch((e) => console.warn("[offline] the service worker is not registered", e));
    });
};
